import React, {memo} from "react";
import {useSelector} from "react-redux";


const InvoiceBody = () => {
    const {invoice} = useSelector(state => state.modalShoppingCard);

    return (
        <React.Fragment>
            <div>
                <div>
                    <ul className={'list-items-invoice-modal'}>

                        {
                            invoice.items.map((item, index) => {
                                return (
                                    <li className={'item-invoice-modal'} key={index}>
                                        <span>{Object.keys(item).toString()}</span>
                                        <span>
                                            <span>{
                                                (Object.keys(item).toString() === 'پرداخت از کیف پول' || Object.keys(item).toString() === 'تخفیف')
                                                    ? parseInt(item[Object.keys(item)]).toLocaleString() + '-' + ' تومان'
                                                    : item[Object.keys(item)]
                                            }</span>
                                        </span>
                                    </li>
                                );
                            })
                        }
                        <li className={'item-invoice-modal'}>
                            <span>قابل پرداخت</span>
                            <span>
                                <span>{(invoice.total_raw < 0 ? 0 : invoice.total_raw).toLocaleString()}</span>
                                <span className={'ml-1'}>تومان</span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
};

export default memo(InvoiceBody);
